'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagEsAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.22869e-06 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -4.01451e-05 6.66667 6.22869e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 5.33333H28V0H6.22869e-06L0 5.33333Z",
          fill: "#DD172C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V14.6667H0V20Z",
          fill: "#DD172C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 14.6667H28V5.33333H0V14.6667Z",
          fill: "#FFD133"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.33333 9.33333H8.66667V10H7.33333V9.33333Z",
          fill: "#FFEDB1"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6 7.73333C6 7.14423 6.47756 6.66667 7.06667 6.66667H7.6C8.1891 6.66667 8.66667 7.14423 8.66667 7.73333C8.66667 7.88061 8.54728 8 8.4 8H6.26667C6.11939 8 6 7.88061 6 7.73333Z",
          fill: "#A41517"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M4 8.66667C4 8.29848 4.29848 8 4.66667 8C5.03486 8 5.33333 8.29848 5.33333 8.66667V12C5.33333 12.3682 5.03486 12.6667 4.66667 12.6667C4.29848 12.6667 4 12.3682 4 12V8.66667Z",
          fill: "#A41517"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.72684 9.38869C5.69445 9.00001 6.00117 8.66666 6.3912 8.66666H8.27547C8.6655 8.66666 8.97222 9.00001 8.93983 9.38869L8.76855 11.444C8.71096 12.1351 8.13328 12.6667 7.43982 12.6667H7.22684C6.53339 12.6667 5.9557 12.1351 5.89812 11.4441L5.72684 9.38869ZM6.44676 10L6.3912 9.33332H8.27547L8.21991 10H6.44676ZM6.50231 10.6667L6.56248 11.3887C6.59127 11.7342 6.88012 12 7.22684 12H7.33333L6.66667 10.6667H6.50231ZM8 10.6667L7.33333 12H7.43982C7.78655 12 8.07539 11.7342 8.10419 11.3887L8.16436 10.6667H8Z",
          fill: "#A41517"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10 8C9.63185 8 9.33337 8.29848 9.33337 8.66667V12C9.33337 12.3682 9.63185 12.6667 10 12.6667C10.3682 12.6667 10.6667 12.3682 10.6667 12V8.66667C10.6667 8.29848 10.3682 8 10 8Z",
          fill: "#A41517"
        }
      )
    ]
  }
);
const VpFlagEsAsset = forwardRef(FlagEsAsset);

export { VpFlagEsAsset as default };
